<template>
  <div>
    <div id="list" v-if="viewType == 'list'">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
                <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                  <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>
                </div>          
                <div class="box-tools">              
                  <button v-on:click="onCreate" class="btn btn-primary">Create</button>
                  <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                </div>
            </div>        
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 45px;text-align:center;">#</th>
                    <th style="text-align:center;">Action</th>
                    <th style="text-align:left;">Project</th>
                    <th style="text-align:left;">BIN</th>
                    <th style="text-align:left;">Card Type</th>
                    <th style="text-align:left;">Card Issuer</th>
                    <th style="text-align:left;">Bank Issuer</th>
                    <th style="text-align:right;">Fee(%)</th>
                    <th style="text-align:right;">Fee Amount</th>
                    <th style="text-align:center;">Currency</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                    <td style="width:85px;text-align:right;">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                      <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                      </a>
                      <a href="#" v-on:click="onDelete(row)" ref="deleteRow" style="padding-right:5px">
                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                      </a>
                    </td>
                    <td>{{ row.projectName }}</td>
                    <td>{{ row.bin }}</td>
                    <td>{{ row.cardType }}</td>
                    <td>{{ row.cardIssuer }}</td>
                    <td>{{ row.bankIssuer }}</td>
                    <td style="text-align:right;">{{ row.feePercentage }}</td>
                    <td style="text-align:right;">{{ row.feeAmount }}</td>
                    <td style="text-align:center;">{{ row.currencyName }}</td>
                    <td hidden>{{ row.id }}</td>
                    <td hidden>{{ row.projectId }}</td>
                    <td hidden>{{ row.currencyId }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                    <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                    Page
                </label>
                <label>
                    <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" type="text" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}                
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                    <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div id="form" v-if="viewType == 'form'">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info">
              <!-- <div class="box-header with-border">
                <h3 class="box-title">Horizontal Form</h3>
              </div> -->
              <form @submit.prevent class="form-horizontal">
                <div class="box-body">
                  <div class="form-group">
                    <label for="inputProjectName" class="col-sm-2 control-label">Project</label>
                    <div class="col-sm-10">
                      <select v-model="formData.projectId" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                        <option v-for="(row, i) in listProject" v-bind:key="i" v-bind:value="row.id">
                          {{ row.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="inputBIN" class="col-sm-2 control-label">BIN</label>
                    <div class="col-sm-10">
                      <select v-model="formData.bin" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false" @change="onChangeBIN()">
                        <option v-for="(row, i) in listBIN" v-bind:key="i" v-bind:value="row.bin">
                          {{ row.bin }} | {{ row.cardType }} | {{ row.cardIssuer }} | {{ row.bankIssuer }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="inputCardType" class="col-sm-2 control-label">Card Type</label>

                    <div class="col-sm-10">
                      <input disabled="true" class="form-control" id="inputCardType" placeholder="Debit or Credit" v-model="formData.cardType">
                    </div>
                  </div>    
                  <div class="form-group">
                    <label for="inputCardIssuer" class="col-sm-2 control-label">Card Issuer</label>

                    <div class="col-sm-10">
                      <input disabled="true" class="form-control" id="inputCardIssuer" placeholder="VISA, MASTERCARD, etc" v-model="formData.cardIssuer">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputBankIssuer" class="col-sm-2 control-label">Bank Issuer</label>

                    <div class="col-sm-10">
                      <input disabled="true" class="form-control" id="inputBankIssuer" placeholder="" v-model="formData.bankIssuer">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputFeePercentage" class="col-sm-2 control-label">Fee (%)</label>

                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputFeePercentage" placeholder="" v-model="formData.feePercentage">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputFeeAmount" class="col-sm-2 control-label">Fee Amount</label>

                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputFeeAmount" placeholder="" v-model="formData.feeAmount">
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="inputCurrencyName" class="col-sm-2 control-label">Currency</label>
                    <div class="col-sm-10">
                      <select v-model="formData.currencyId" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                        <option v-for="(row, i) in listCurrency" v-bind:key="i" v-bind:value="row.id">
                          {{ row.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
                </div>
                <!-- /.box-body -->
                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
                  </div>
                </div>
                <!-- /.box-footer -->
              </form>
            </div>          
          </div>
        </div>
      </div> 
    </transition>  
  </div>  
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'
import axios from 'axios'

const VIEW_LIST = 'list'
const VIEW_FORM = 'form'
const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'

export default {
  name: 'Card Fee',
  data() {
    return {
      VIEW_LIST: VIEW_LIST,
      VIEW_FORM: VIEW_FORM,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      column: '',
      item: null,
      listData: null,
      listCurrency: null,
      listProject: null,
      listBIN: null,
      listCardFee: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'BIN'
      },
      viewType: VIEW_LIST,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        projectId: 0,
        projectName: '',
        bin: '',
        cardType: '',
        cardIssuer: '',
        bankIssuer: '',
        feePercentage: 0,
        feeAmount: 0,
        currencyId: 0,
        currencyName: ''
      }
    }
  },
  created() {
    this.viewType = VIEW_LIST
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    inquiry() {
      const reqProject = api.request('Account', 'get', '/api/Project/InquiryAll', null)
      const reqCurrency = api.request('Account', 'get', '/api/Currency/InquiryAll', null)
      const reqBIN = api.request('Sales', 'get', '/api/sales/bin/all', null)
      const reqCardFee = api.request('Sales', 'get', '/api/sales/cardfee?WhereClause=' + this.inquiryParam.WhereClause +
                                                      '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                                      '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)

      axios
        .all([reqProject, reqCurrency, reqBIN, reqCardFee])
        .then(
          axios.spread((...response) => {
            const respProject = response[0]
            const respCurrency = response[1]
            const respBIN = response[2]
            const respCardFee = response[3]

            this.listProject = respProject.data.entity
            this.listCurrency = respCurrency.data.entity
            this.listBIN = respBIN.data.entity
            this.listCardFee = respCardFee.data.entity
            this.total = respCardFee.data.totalRows
            this.totalPages = respCardFee.data.totalPages

            this.combineInquiry()
          })
        )
        .catch(error => {
          SweetAlert.fire('Error', error.message, 'error')
        })
    },
    combineInquiry() {
      this.listCardFee.forEach(cardFee => {
        this.listCurrency.some(function(itemCurrency, index) {
          if (cardFee.currencyId === itemCurrency.id) {
            cardFee.currencyName = itemCurrency.name
          }
        })

        this.listProject.some(function(itemProject, index) {
          if (cardFee.projectId === itemProject.id) {
            cardFee.projectName = itemProject.name
          }
        })

        this.listBIN.some(function(itemBIN, index) {
          if (cardFee.bin === itemBIN.bin) {
            cardFee.bin = itemBIN.bin
            cardFee.cardType = itemBIN.cardType
            cardFee.cardIssuer = itemBIN.cardIssuer
            cardFee.bankIssuer = itemBIN.bankIssuer
          }
        })
      })
      this.listData = this.listCardFee
    },
    initForm() {
      this.formData.name = ''
    },
    onCreate() {
      this.initForm()
      this.viewType = VIEW_FORM
      this.viewMode = MODE_CREATE
    },
    onDisplay(row) {
      this.viewType = VIEW_FORM
      this.viewMode = MODE_VIEW

      this.formData.id = row.id
      this.formData.projectId = row.projectId
      this.formData.bin = row.bin
      this.formData.cardType = row.cardType
      this.formData.cardIssuer = row.cardIssuer
      this.formData.bankIssuer = row.bankIssuer
      this.formData.feePercentage = row.feePercentage
      this.formData.feeAmount = row.feeAmount
      this.formData.currencyId = row.currencyId
    },
    onEdit(data) {
      this.formData.id = data.id
      this.formData.projectId = data.projectId
      this.formData.bin = data.bin
      this.formData.cardType = data.cardType
      this.formData.cardIssuer = data.cardIssuer
      this.formData.bankIssuer = data.bankIssuer
      this.formData.feePercentage = data.feePercentage
      this.formData.feeAmount = data.feeAmount
      this.formData.currencyId = data.currencyId
      this.viewType = VIEW_FORM
      this.viewMode = MODE_UPDATE
    },
    onDelete(data) {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.delete(data)
          SweetAlert.fire('Deleted', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
        }
      })
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.inquiry()
      this.viewType = VIEW_LIST
    },
    onChangeBIN() {
      const binSelected = this.formData.bin
      let cardType = ''
      let cardIssuer = ''
      let bankIssuer = ''

      this.listBIN.some(function(itemBIN, index) {
        if (itemBIN.bin === binSelected) {
          cardType = itemBIN.cardType
          cardIssuer = itemBIN.cardIssuer
          bankIssuer = itemBIN.bankIssuer

          return
        }
      })

      this.formData.cardType = cardType
      this.formData.cardIssuer = cardIssuer
      this.formData.bankIssuer = bankIssuer
    },
    onSave() {
      var data = {
        Id: this.formData.id,
        ProjectId: this.formData.projectId,
        BIN: this.formData.bin,
        FeePercentage: this.formData.feePercentage,
        FeeAmount: this.formData.feeAmount,
        CurrencyId: this.formData.currencyId
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'post'
          break
        case MODE_UPDATE:
          method = 'put'
          break
      }

      api
        .request('Sales', method, '/api/sales/cardfee', data)
        .then(response => {
          var resData = response.data
          this.formData.id = resData.entity.id
          this.formData.projectId = resData.entity.projectId
          this.formData.bin = resData.entity.bin
          this.formData.feePercentage = resData.entity.feePercentage
          this.formData.feeAmount = resData.entity.feeAmount
          this.formData.currencyId = resData.entity.currencyId
          this.total = resData.totalRows

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.onDisplay({
              id: this.formData.id,
              projectId: this.formData.projectId,
              bin: this.formData.bin,
              cardType: this.formData.cardType,
              cardIssuer: this.formData.cardIssuer,
              bankIssuer: this.formData.bankIssuer,
              feePercentage: this.formData.feePercentage,
              feeAmount: this.formData.feeAmount,
              currencyId: this.formData.currencyId
            })
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    delete(data) {
      var status = ''
      var message = ''
      var reqData = {
        Id: data.id
      }
      api.request('Sales', 'delete', '/api/sales/cardfee', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.inquiry()
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    }
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// CardFee.vue?2fca6b21